import { render, staticRenderFns } from "./HesapAktivasyonu.vue?vue&type=template&id=50cb69c5&scoped=true"
import script from "./HesapAktivasyonu.vue?vue&type=script&lang=js"
export * from "./HesapAktivasyonu.vue?vue&type=script&lang=js"
import style0 from "./HesapAktivasyonu.vue?vue&type=style&index=0&id=50cb69c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb69c5",
  null
  
)

export default component.exports